module.exports = __webpack_public_path__ + "img/mapicon-yellow.d0e4ac86.svg";